import { EventInteraction, EventInteractionContext } from '@eventbrite/ads';
import { FormattedEvent } from '@eventbrite/event-renderer';
import { getBaseTrackingContext } from '../../../utils/tracking';

export function aggregateTrackingContext({
    event,
    eventSearch,
    searchId,
    events = [],
    userId,
    currentPage,
    locale,
    sessionId,
    guestId,
}: Omit<EventInteraction, 'action'> & {
    eventSearch: any;
    searchId: string;
    events: FormattedEvent[] | undefined;
    userId: string;
    currentPage: number;
    locale?: string;
    sessionId: string;
    guestId: string;
}): EventInteractionContext {
    const SEARCH_PLACEMENT_NAME = 'search';

    const baseTrackingContext = getBaseTrackingContext({
        event,
        events,
        userId,
        locale,
        guestId,
        sessionId,
    });

    return {
        ...baseTrackingContext,
        place: {
            name: SEARCH_PLACEMENT_NAME,
            page: currentPage,
            context: {
                date_filter: eventSearch.dates || null,
                query_terms: eventSearch.q || null,
                search_id: searchId,
                ...computeLocationInfo(eventSearch),
            },
            ...baseTrackingContext.place,
        },
    };
}

export function computeLocationInfo(eventSearch: any) {
    const placeId = Array.isArray(eventSearch.places)
        ? eventSearch.places[0]
        : null;

    if (eventSearch.onlineEventsOnly) {
        return {
            is_online: true,
        };
    }

    if (eventSearch.bbox) {
        const { latitude, longitude } = getBboxCenterCoordinates(
            eventSearch.bbox,
        );
        return {
            is_online: false,
            latitude,
            longitude,
            place_id: placeId,
        };
    }

    return {
        is_online: false,
        place_id: placeId,
    };
}

export function getBboxCenterCoordinates(bbox: string) {
    try {
        const [swLng, swLat, neLng, neLat] = bbox.split(',').map(Number);
        const latitude = `${(neLat + swLat) / 2}`;
        const longitude = `${(neLng + swLng) / 2}`;
        return {
            latitude,
            longitude,
        };
    } catch (e) {
        return { latitude: undefined, longitude: undefined };
    }
}
